import React from 'react';
import Button, {ButtonProps} from 'antd/lib/button';
import {UserApi, UserDto} from '../../scaffold';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {useBoolean} from 'react-hanger';
import {Modal, Spin} from 'antd';
import PersonalApproveTable from './PersonalApproveTable';
export interface IUserViewBtnProps extends ButtonProps {
  user: UserDto;
}
export default function UserViewBtn(props: IUserViewBtnProps) {
  const {user, ...rest} = props;
  const findHook = useOpenApiFpRequest(UserApi, UserApi.prototype.userFindGet);
  const isView = useBoolean(false);
  return (
    <div>
      <Button
        {...rest}
        onClick={() => {
          findHook.requestSync({id: user.id || 0});
          isView.setTrue();
        }}
      />
      <Modal width={1200} visible={isView.value} onCancel={isView.setFalse} footer={false} title={'会员信息: ' + props.user.memberNo}>
        <Spin spinning={findHook.loading}>
          {findHook.data && (
            <div className={'p-b-20'}>
              <PersonalApproveTable approve={findHook.data.personalApprove} readonly />
            </div>
          )}
        </Spin>
      </Modal>
    </div>
  );
}
